module.exports = __webpack_public_path__ + "8672ba5f7b4dc48bb1a97e1916006caa.png";